import { observer } from 'mobx-react-lite'
import { type ReactNode, useEffect } from 'react'
import { DropdownContent, Tabs } from 'shared/ui'
import { type IScheduleType } from 'shared/ui/Schedule'
import { useScheduleContext } from 'shared/ui/Schedule/context/ScheduleContext'
import { Immediately } from 'shared/ui/Schedule/ui/Immediately'
import { SendLater } from 'shared/ui/Schedule/ui/SendLater'
import { Recurring } from 'shared/ui/Schedule/ui/Recurring'
import styles from './styles.module.scss'

type IScheduleDropdownContentProps = {
  onCloseMenu: () => void
  dropdownId: string
}

export const ScheduleDropdownContent = observer(
  ({ onCloseMenu, dropdownId }: IScheduleDropdownContentProps) => {
    const {
      setOnCloseMenu,
      tabs,
      type,
      handleSelectTab,
      immediatelyStore,
      setDropdownId,
      sendLaterStore,
      recurringStore,
    } = useScheduleContext()

    useEffect(() => {
      setOnCloseMenu(onCloseMenu)
      setDropdownId(dropdownId)
    }, [])

    const content: { [key in IScheduleType]: ReactNode } = {
      immediately: <Immediately store={immediatelyStore} />,
      later: <SendLater store={sendLaterStore} />,
      recurring: <Recurring store={recurringStore} />,
    }

    return (
      <>
        <DropdownContent noPadding className={styles.wrap}>
          <Tabs
            tabs={tabs}
            activeTabKey={type}
            handleSelectTab={handleSelectTab}
            variant={'simple'}
            gap={4}
            tabsClassName={styles.tabs}
          />
          {content[type]}
        </DropdownContent>
      </>
    )
  }
)
